import { ITheme } from '@/store/theme/interface'

export const themeConfig: ITheme = {
	sidebarStyle: 'dark',
	headerStyle: 'light',
	primaryColor: '#409eff',
	layout: 'vertical',
	uniqueOpened: true,
	isLogo: true,
	isBreadcrumb: true,
	isTabsView: true,
	isTabsCache: true,
	tabsStyle: 'style-1',
	msgNotify: false,
}
